import React, { useEffect } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import useLenis from "./hooks/useLenis";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import BrandsMarquee from "./components/site/BrandsMarquee";
import Solutions from "./components/site/Solutions";
import Industries from "./components/site/Industries";
import WhyChooseUs from "./components/site/WhyChooseUs";
import Testimonials from "./components/site/Testimonials";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";
import ScrollProgress from "./components/site/ScrollProgress";
import WhatsAppFab from "./components/site/WhatsAppFab";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function MarketingSite() {
  useLenis();
  return (
    <div className="App grain min-h-screen bg-[#444444] text-[#FAFAFA] font-body" data-testid="app-root">
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <BrandsMarquee />
        <Solutions />
        <Industries />
        <WhyChooseUs />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

function App() {
  useEffect(() => {
    document.title = "DB Computronics · Enterprise IT Solutions Since 2000";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingSite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#222222",
            color: "#FAFAFA",
            border: "1px solid rgba(154,154,154,0.25)",
            borderRadius: "10px",
            fontFamily: "Inter, system-ui, sans-serif",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
